import { NotFound } from '../pages/NotFound';
import * as Sentry from '@sentry/react';
import { PageHeader } from './ui';

export const ToDoPage = (): JSX.Element => {
    if (!import.meta.env.DEV) {
        // If this page appears in PROD, send a Sentry notification and display "Not Found"
        Sentry.captureMessage(
            `The ToDo page has been viewed in PROD.  This is an incomplete feature and should be inaccessible outside of develop.`,
        );
        return <NotFound />;
    }
    return (
        <div className="page-container">
            <PageHeader
                title="ToDo Page"
                signalLine="This is a placeholder. If you see this component, that means that this content still for this feature needs to be created."
            />
        </div>
    );
};